<div class="min-h-screen bg-[#F3F4F6] text-sm dark:bg-slate-900 p-4 md:p-8   text-slate-600 dark:text-slate-300">

    <!-- Header (Standard Project Style) -->
    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
        <div>
            <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight tracking-tight">
                จัดการประเภทค่าปรับ
            </h1>
            <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
                ตั้งค่าข้อมูลค่าปรับและภาษีแยกตามรายได้และพื้นที่</p>
        </div>
        <div class="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
            <button (click)="onRefresh()"
                class="w-full sm:w-auto p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 flex items-center justify-center h-[46px]"
                title="รีเฟรชข้อมูล">
                <span class="material-icons">refresh</span>
            </button>
            <button (click)="openCreateModal()"
                class="w-full sm:w-auto px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-[0_4px_15px_rgb(251,191,36,0.3)] hover:shadow-[0_8px_25px_rgb(251,191,36,0.4)] hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-2 h-[46px]">
                <span class="material-icons text-xl">add_circle</span>
                สร้างประเภทค่าปรับ
            </button>
        </div>
    </div>

    <!-- Dashboard stats (Standard Project Style) -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8 mt-2">
        <div *ngFor="let stat of stats; let i = index"
            class="animate-fade-in bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] dark:hover:shadow-[0_8px_30px_rgb(0,0,0,0.3)] hover:-translate-y-1 transition-all duration-300 group relative overflow-hidden"
            [style.animation-delay]="(i * 100) + 'ms'">

            <!-- Background Icon Decoration -->
            <div class="absolute -right-6 -top-6 w-32 h-32 rounded-full opacity-[0.08] dark:opacity-10 transition-transform group-hover:scale-110"
                [ngClass]="stat.color.split(' ')[0].replace('text-', 'bg-')"></div>

            <div class="relative z-10 flex justify-between items-start mb-4">
                <div class="w-12 h-12 p-2 rounded-xl flex items-center justify-center shadow-sm transition-transform group-hover:scale-110 duration-500"
                    [ngClass]="stat.color.replace('text-', 'bg-').replace('600', '50').replace('500', '50') + ' ' + stat.color + ' dark:bg-opacity-20'">
                    <span class="material-icons text-2xl">{{ stat.icon }}</span>
                </div>
            </div>

            <div class="relative z-10">
                <h4 class="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1 truncate">{{ stat.title }}
                </h4>
                <div class="text-2xl font-black text-slate-800 dark:text-slate-100 tracking-tight">
                    {{ (stat.title.includes('รายได้') || stat.title.includes('สูงสุด')) ? '฿' : '' }}
                    {{ stat.value | number }}
                </div>
            </div>
        </div>
    </div>

    <!-- Main Table Container (Standard Project Style) -->
    <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 overflow-hidden"
        style="animation-delay: 0.2s;">

        <!-- Table Header Control Bar -->
        <div
            class="p-6 border-b border-slate-100 dark:border-slate-700 flex flex-col md:flex-row md:items-center justify-between gap-4">
            <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
                <span class="material-icons text-amber-500">receipt_long</span>
                รายการค่าปรับรายพื้นที่
            </h3>

            <div class="flex flex-col xl:flex-row gap-3 w-full xl:w-auto">

                <!-- Amount Max Filter -->
                <div class="relative min-w-[180px]">
                    <div
                        class="relative flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100/50 dark:border-slate-800 h-[46px] shadow-sm overflow-hidden focus-within:ring-2 focus-within:ring-amber-200">
                        <span
                            class="pl-4 text-[10px] font-black text-slate-400 uppercase tracking-tighter">สูงสุด:</span>
                        <input type="number" placeholder="จำนวนเงิน..." [(ngModel)]="filterMaxAmount"
                            (input)="onAmountFilterChange()"
                            class="w-full px-2 py-2 bg-transparent border-none text-sm font-bold text-slate-600 dark:text-slate-300 focus:ring-0 outline-none">
                    </div>
                </div>

                <!-- VAT Filter (Custom Dropdown) -->
                <div class="relative min-w-[150px]">
                    <button (click)="isVatDropdownOpen = !isVatDropdownOpen"
                        class="w-full flex items-center justify-between px-4 py-2 bg-slate-50 dark:bg-slate-900 border border-slate-100/50 dark:border-slate-800 rounded-xl h-[46px] shadow-sm text-sm font-bold text-slate-600 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-800 transition-all">
                        <span class="flex items-center gap-2">
                            <span class="material-icons text-lg text-slate-400">payments</span>
                            {{ filterVat === 'yes' ? 'รวมภาษี' : (filterVat === 'no' ? 'ไม่รวมภาษี' : 'ทั้งหมด (ภาษี)')
                            }}
                        </span>
                        <span class="material-icons text-sm text-slate-400 transition-transform duration-200"
                            [ngClass]="{'rotate-180': isVatDropdownOpen}">expand_more</span>
                    </button>

                    <!-- Overlay backdrop -->
                    <button *ngIf="isVatDropdownOpen" class="fixed inset-0 cursor-default z-30"
                        (click)="isVatDropdownOpen = false"></button>

                    <!-- Dropdown List -->
                    <div *ngIf="isVatDropdownOpen"
                        class="absolute top-full right-0 mt-2 w-full bg-white dark:bg-slate-800 rounded-2xl shadow-dropdown border border-slate-100 dark:border-slate-700 py-3 z-40 animate-fade-in-up">
                        <div (click)="selectVatFilter('')"
                            class="px-4 py-2.5 text-sm font-bold text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 cursor-pointer transition-all flex items-center justify-between">
                            <span>ทุกสถานะ</span>
                            <span *ngIf="!filterVat" class="material-icons text-amber-500 text-lg">check_circle</span>
                        </div>
                        <div (click)="selectVatFilter('yes')"
                            class="px-4 py-2.5 text-sm font-bold text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 cursor-pointer transition-all flex items-center justify-between">
                            <span>รวมภาษี</span>
                            <span *ngIf="filterVat === 'yes'"
                                class="material-icons text-amber-500 text-lg">check_circle</span>
                        </div>
                        <div (click)="selectVatFilter('no')"
                            class="px-4 py-2.5 text-sm font-bold text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 cursor-pointer transition-all flex items-center justify-between">
                            <span>ไม่รวมภาษี</span>
                            <span *ngIf="filterVat === 'no'"
                                class="material-icons text-amber-500 text-lg">check_circle</span>
                        </div>
                    </div>
                </div>



                <!-- Site Filter Dropdown -->
                <div class="relative min-w-[200px]">
                    <button (click)="toggleFilterDropdown()"
                        class="w-full flex items-center justify-between px-4 py-2 bg-slate-50 dark:bg-slate-900 border border-slate-100/50 dark:border-slate-800 rounded-xl h-[46px] shadow-sm text-sm font-bold text-slate-600 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-800 transition-all">
                        <span class="flex items-center gap-2">
                            <span class="material-icons text-lg text-slate-400">place</span>
                            {{ filterSite || 'ทั้งหมด (ทุกพื้นที่)' }}
                        </span>
                        <span class="material-icons text-sm text-slate-400 transition-transform duration-200"
                            [ngClass]="{'rotate-180': isFilterDropdownOpen}">expand_more</span>
                    </button>

                    <!-- Overlay backdrop -->
                    <button *ngIf="isFilterDropdownOpen" class="fixed inset-0 cursor-default z-30"
                        (click)="toggleFilterDropdown()"></button>

                    <!-- Dropdown List -->
                    <div *ngIf="isFilterDropdownOpen"
                        class="absolute top-full right-0 mt-2 w-[250px] bg-white dark:bg-slate-800 rounded-2xl shadow-dropdown border border-slate-100 dark:border-slate-700 py-3 z-40 animate-fade-in-up">
                        <div
                            class="px-4 pb-2 mb-2 text-[10px] font-black text-slate-400 uppercase tracking-widest border-b border-slate-50 dark:border-slate-700/50">
                            กรองตามพื้นที่</div>
                        <div (click)="selectSiteFilter('')"
                            class="px-4 py-2.5 text-sm font-bold text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 cursor-pointer transition-all flex items-center justify-between">
                            <span>ทุกพื้นที่</span>
                            <span *ngIf="!filterSite" class="material-icons text-amber-500 text-lg">check_circle</span>
                        </div>
                        <div *ngFor="let site of siteOptions" (click)="selectSiteFilter(site)"
                            class="px-4 py-2.5 text-sm font-bold text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 cursor-pointer transition-all flex items-center justify-between">
                            <span>{{ site }}</span>
                            <span *ngIf="filterSite === site"
                                class="material-icons text-amber-500 text-lg">check_circle</span>
                        </div>
                    </div>
                </div>

                <!-- Search Input -->
                <div class="relative flex-1 flex w-full xl:min-w-[400px]">
                    <div
                        class="relative w-full flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100/50 dark:border-slate-800 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 transition-all overflow-hidden h-[46px]">
                        <span
                            class="absolute left-4 material-icons text-slate-400 dark:text-slate-500 text-xl">search</span>
                        <input type="text" placeholder="หาตามชื่อค่าปรับ หรือ พื้นที่..." [(ngModel)]="searchText"
                            (input)="applyFilters()"
                            class="w-full pl-12 pr-4 py-2 bg-transparent border-none text-sm font-bold text-slate-600 dark:text-slate-300 focus:ring-0 focus:outline-none placeholder:text-slate-400 dark:placeholder:text-slate-500">
                    </div>
                </div>
            </div>
        </div>

        <!-- Table Container -->
        <div class="overflow-x-auto min-h-[500px] relative custom-scrollbar">
            <app-pss-loading *ngIf="isLoading"></app-pss-loading>

            <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading">
                <thead
                    class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm shadow-sm border-b border-slate-100 dark:border-slate-700">
                    <tr class="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-[0.15em]">
                        <th class="p-6 pl-10 text-center">ID</th>
                        <th (click)="sortData('name')"
                            class="p-6 cursor-pointer hover:text-slate-700 transition-colors group">
                            <div class="flex items-center gap-1.5">
                                ชื่อค่าปรับ
                                <span
                                    class="material-icons text-xs opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                    [class.opacity-100]="sortColumn === 'name'">
                                    {{ sortColumn === 'name' && sortDirection === 'asc' ? 'north' : 'south' }}
                                </span>
                            </div>
                        </th>
                        <th (click)="sortData('amount')"
                            class="p-6 cursor-pointer hover:text-slate-700 transition-colors group">
                            <div class="flex items-center gap-1.5">
                                จำนวนเงิน (฿)
                                <span
                                    class="material-icons text-xs opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                    [class.opacity-100]="sortColumn === 'amount'">
                                    {{ sortColumn === 'amount' && sortDirection === 'asc' ? 'north' : 'south' }}
                                </span>
                            </div>
                        </th>
                        <th class="p-6 text-center">รวมภาษี</th>
                        <th class="p-6 whitespace-nowrap">รายได้</th>
                        <th class="p-6 whitespace-nowrap">พื้นที่ให้บริการ</th>
                        <th class="p-6 text-center pr-10">จัดการ</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
                    <tr *ngFor="let f of paginatedFines"
                        class="group hover:bg-amber-50/30 dark:hover:bg-slate-700/40 transition-all duration-200 cursor-pointer animate-table-row"
                        (click)="openEditModal(f)">

                        <td class="p-5 pl-10 text-center font-mono text-xs font-black text-slate-400">{{ f.id }}</td>

                        <td class="p-5">
                            <div class="flex items-center gap-3">
                                <div class="w-2.5 h-2.5 rounded-full bg-amber-400"></div>
                                <span
                                    class="text-sm font-black text-slate-700 dark:text-slate-200 group-hover:text-amber-600 transition-colors">{{
                                    f.name }}</span>
                            </div>
                        </td>

                        <td class="p-5">
                            <span class="text-sm font-black text-slate-700 dark:text-slate-200">{{ f.amount |
                                number:'1.2-2' }}</span>
                        </td>

                        <td class="p-5 text-center">
                            <div class="flex justify-center">
                                <div class="w-6 h-6 rounded-lg flex items-center justify-center transition-all border"
                                    [ngClass]="f.isVatIncluded ? 'bg-emerald-500 border-emerald-500 text-white shadow-emerald-200 shadow-lg' : 'bg-white dark:bg-slate-900 border-slate-200 text-transparent'">
                                    <span class="material-icons text-sm font-black">check</span>
                                </div>
                            </div>
                        </td>

                        <td class="p-5">
                            <span
                                class="px-3 py-1 bg-slate-100 dark:bg-slate-900 rounded-lg text-xs font-bold text-slate-500 whitespace-nowrap">{{
                                f.revenueName }}</span>
                        </td>

                        <td class="p-5">
                            <span
                                class="inline-flex items-center gap-2 px-4 py-1.5 bg-amber-50 dark:bg-amber-900/10 text-amber-600 dark:text-amber-400 text-[10px] font-black rounded-xl border border-amber-100/50 uppercase tracking-widest shadow-sm">
                                <span class="material-icons text-xs">place</span>
                                {{ f.site }}
                            </span>
                        </td>

                        <td class="p-5 text-center pr-10">
                            <button (click)="openEditModal(f); $event.stopPropagation()"
                                class="inline-flex items-center justify-center w-10 h-10 rounded-2xl text-blue-500 bg-blue-50 dark:bg-blue-900/30 hover:bg-blue-500 hover:text-white transition-all shadow-sm hover:scale-110 active:scale-95 group-hover:shadow-blue-200 opacity-0 group-hover:opacity-100">
                                <span class="material-icons text-sm">edit</span>
                            </button>
                        </td>
                    </tr>

                    <!-- Empty State -->
                    <tr *ngIf="filteredFines.length === 0 && !isLoading">
                        <td colspan="7" class="py-24 text-center">
                            <div class="flex flex-col items-center justify-center grayscale opacity-30">
                                <span class="material-icons text-6xl">receipt</span>
                                <h3 class="text-lg font-black uppercase tracking-widest mt-6">ไม่พบข้อมูลค่าปรับ</h3>
                                <p class="text-sm font-bold mt-1 text-slate-400">ลองตรวจสอบตัวเลือกการค้นหาอีกครั้ง</p>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Pagination Footer (Standard Project Style) -->
        <div
            class="px-8 py-6 border-t border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 flex flex-col md:flex-row items-center justify-between gap-6 w-full rounded-b-3xl">
            <div class="flex items-center gap-6 text-sm text-slate-500 dark:text-slate-400 font-bold">
                <span>แสดง {{ ((currentPage-1)*pageSize) + 1 }} - {{ currentPage * pageSize > totalItems ? totalItems :
                    currentPage * pageSize }} จาก {{ totalItems | number }} รายการ</span>
                <div class="flex items-center gap-3">
                    <span class="text-[10px] font-black uppercase tracking-[0.1em] opacity-60">ต่อหน้า:</span>
                    <div class="relative">
                        <select (change)="onPageSizeChange($event)" [(ngModel)]="pageSize"
                            class="appearance-none bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-200 text-xs rounded-xl block w-24 p-2.5 pr-8 font-black outline-none cursor-pointer hover:bg-white dark:hover:bg-slate-800 shadow-sm transition-all">
                            <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} รายการ</option>
                        </select>
                        <span
                            class="material-icons absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400 text-sm">expand_more</span>
                    </div>
                </div>
            </div>

            <div class="flex items-center gap-2.5">
                <button (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1"
                    class="w-11 h-11 flex items-center justify-center rounded-2xl border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500 group">
                    <span
                        class="material-icons text-lg group-hover:-translate-x-0.5 transition-transform">chevron_left</span>
                </button>

                <div class="flex items-center gap-2">
                    <button *ngFor="let page of pagesArray" (click)="setPage(page)"
                        class="w-11 h-11 flex items-center justify-center rounded-2xl text-xs font-black transition-all border"
                        [ngClass]="page === currentPage 
                            ? 'bg-amber-400 border-amber-400 text-white shadow-lg shadow-amber-200 dark:shadow-none' 
                            : 'border-transparent text-slate-500 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600'">
                        {{ page }}
                    </button>
                </div>

                <button (click)="setPage(currentPage + 1)" [disabled]="currentPage === totalPages || totalPages === 0"
                    class="w-11 h-11 flex items-center justify-center rounded-2xl border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500 group">
                    <span
                        class="material-icons text-lg group-hover:translate-x-0.5 transition-transform">chevron_right</span>
                </button>
            </div>
        </div>
    </div>

    <!-- Modals -->
    <app-modal-fine *ngIf="isModalOpen" [fineData]="selectedFine" (close)="closeModal()"
        (saveSuccess)="onRefresh()"></app-modal-fine>

</div>